import { NavLink } from "react-router-dom";
import { Globe, Network, Gauge, Users, Calculator, CalendarRange, Map, FolderOpen, ScanSearch, Wine, PlayCircle, ClipboardList, TreeDeciduous } from "lucide-react";
import { t, useLang } from "@/lib/i18n";

const NAV = [
  { to: "/", label: "Albero", icon: Network, id: "tree" },
  { to: "/mappa", label: t("Mappa albero"), icon: TreeDeciduous, id: "map" },
  { to: "/cockpit", label: "Cockpit", icon: Gauge, id: "cockpit" },
  { to: "/team", label: "Team", icon: Users, id: "team" },
  { to: "/calcolatori", label: "Calcolatori", icon: Calculator, id: "calculators" },
  { to: "/inventario", label: t("Inventario rapido"), icon: ClipboardList, id: "inventory" },
  { to: "/eventi", label: "Eventi", icon: CalendarRange, id: "events" },
  { to: "/vini", label: t("Carta vini"), icon: Wine, id: "wines" },
  { to: "/territorio", label: "Territorio", icon: Map, id: "territory" },
  { to: "/corpus", label: "Corpus", icon: FolderOpen, id: "corpus" },
  { to: "/analisi", label: t("Analisi gap"), icon: ScanSearch, id: "gaps" },
  { to: "/guida", label: t("Guida video"), icon: PlayCircle, id: "guide" },
];

export const LangButton = () => {
  const { lang, setLang } = useLang();
  const next = lang === "it" ? "en" : "it";
  return (
    <button data-testid="lang-toggle-button" onClick={() => setLang(next)} title={lang === "it" ? "Switch to English" : "Passa all'italiano"}
      className="fixed top-3 right-3 z-[60] flex items-center gap-2 h-11 px-4 rounded-full bg-primary text-primary-foreground font-bold text-sm shadow-lg shadow-black/40 hover:brightness-110 active:scale-95 transition-[transform,filter]">
      <Globe size={17} /> {lang === "it" ? "ENGLISH" : "ITALIANO"}
    </button>
  );
};

const LangSwitch = ({ compact }) => {
  const { lang, setLang } = useLang();
  return (
    <div data-testid="lang-switch" className={`flex p-0.5 rounded-md border border-border bg-background ${compact ? "" : "w-full"}`}>
      {["it", "en"].map((l) => (
        <button key={l} data-testid={`lang-${l}`} onClick={() => setLang(l)} className={`flex-1 text-[11px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded ${lang === l ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}>{l === "it" ? "Italiano" : "English"}</button>
      ))}
    </div>
  );
};

export const Sidebar = () => (
  <>
    <aside className="hidden lg:flex fixed inset-y-0 left-0 w-60 flex-col border-r border-border bg-card/80 backdrop-blur-xl z-30">
      <div className="px-5 py-6 border-b border-border">
        <div className="flex items-center gap-2.5">
          <span className="h-9 w-9 rounded-md bg-primary/15 border border-primary/40 flex items-center justify-center text-primary"><Wine size={18} /></span>
          <div>
            <div className="font-heading font-bold leading-tight tracking-tight">{t("F&B Wine")}</div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">{t("Management")}</div>
          </div>
        </div>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1">
        {NAV.map(({ to, label, icon: Icon, id }) => (
          <NavLink key={to} to={to} end={to === "/"} data-testid={`nav-${id}`}
            className={({ isActive }) => `flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors ${isActive ? "bg-primary/15 text-primary border border-primary/30" : "text-muted-foreground hover:text-foreground hover:bg-accent border border-transparent"}`}>
            <Icon size={16} /> {t(label)}
          </NavLink>
        ))}
      </nav>
      <div className="px-4 py-3 border-t border-border"><LangSwitch /></div>
      <div className="px-5 pb-4 text-[11px] text-muted-foreground">{t("Uso personale · motore a regole · corpus in espansione")}</div>
    </aside>
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-30 border-t border-border bg-card/95 backdrop-blur-xl flex overflow-x-auto">
      {NAV.map(({ to, label, icon: Icon, id }) => (
        <NavLink key={to} to={to} end={to === "/"} data-testid={`nav-mobile-${id}`}
          className={({ isActive }) => `flex-1 min-w-[68px] flex flex-col items-center gap-1 py-2 text-[10px] ${isActive ? "text-primary" : "text-muted-foreground"}`}>
          <Icon size={16} /> {t(label)}
        </NavLink>
      ))}
      <div className="flex items-center px-2"><LangSwitch compact /></div>
    </nav>
  </>
);
